import type { ClientPoll } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { getPollOptions } from '@/features/post-editor/utils/poll';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    answers: { gap: 10 },
    barHeader: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingStart: 16,
      paddingVertical: 8
    },
    bar: {
      height: 12,
      backgroundColor: theme.colors.surfaceContainerHighest,
      borderRadius: 12,
      overflow: 'hidden'
    },
    barFill: {
      height: '100%',
      backgroundColor: theme.colors.error
    }
  });

type Props = {
  poll: ClientPoll;
};

export const PollResults: FC<Props> = ({ poll }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const { t } = useTranslation(LocalizationNameSpace.POSTS, {
    keyPrefix: 'components.poll'
  });

  const pollOptions = getPollOptions(poll);

  return (
    <View style={styles.answers}>
      {pollOptions.map(({ optionText, votes, percentage }) => (
        <View key={optionText}>
          <View style={styles.barHeader}>
            <Text variant="labelLarge" style={{ flex: 1 }}>
              {optionText}
            </Text>
            <Text variant="labelLarge">
              {t('voteCount', {
                votes,
                percentage: Number.parseFloat(percentage.toFixed(2))
                  .toString()
                  .replace('.', ',')
              })}
            </Text>
          </View>
          <View style={styles.bar}>
            <View style={[styles.barFill, { width: `${percentage}%` }]} />
          </View>
        </View>
      ))}
    </View>
  );
};
